export enum Screens {
  ENTER_LICENSE_PLATE = 'ENTER_LICENSE_PLATE',
  ENTER_LICENSE_PLATE_MANUALLY = 'ENTER_LICENSE_PLATE_MANUALLY',
  VEHICLE_MANUAL_ENTER = 'VEHICLE_MANUAL_ENTER',
  VERIFY_VEHICLE_INFO = 'VERIFY_VEHICLE_INFO',
  YOUR_INFO = 'YOUR_INFO',
  YOUR_INFORMATION_MANUALLY = 'YOUR_INFORMATION_MANUALLY',
  TWO_YEARS_ADDRESS_HISTORY = 'TWO_YEARS_ADDRESS_HISTORY',
  CURRENT_ADDRESS_INFO = 'CURRENT_ADDRESS_INFO',
  CURRENT_ADDRESS_INFO_MANUALLY = 'CURRENT_ADDRESS_INFO_MANUALLY',
  EMPLOYMENT_AND_INCOME = 'EMPLOYMENT_AND_INCOME',
  INCOME_SOURCES = 'INCOME_SOURCES',
  OFFER_SELECTION = 'OFFER_SELECTION',
  OFF_RAMP = 'OFF_RAMP',
  NEXT_STEPS = 'NEXT_STEPS',
  CHECKLIST_STATUS = 'CHECKLIST_STATUS',
  DISQUALIFIED = 'DISQUALIFIED',
  DISQUALIFIED_DECLINE_LOW_CREDIT_SCORE = 'DISQUALIFIED_DECLINE_LOW_CREDIT_SCORE',
  DISQUALIFIED_DECLINE_DEFAULT_CREDIT_SCORE = 'DISQUALIFIED_DECLINE_DEFAULT_CREDIT_SCORE',
  THANK_YOU = 'THANK_YOU',
  FINAL_OFFER = 'FINAL_OFFER',
  VERIFY_MOBILE_NUMBER = 'VERIFY_MOBILE_NUMBER',
  VERIFY_MOBILE_NUMBER_CHECK_YOUR_PHONE = 'VERIFY_MOBILE_NUMBER_CHECK_YOUR_PHONE',
  VERIFY_MOBILE_NUMBER_COMPLETE = 'VERIFY_MOBILE_NUMBER_COMPLETE',
  SOFT_PULL_ACKNOWLEDGEMENT = 'SOFT_PULL_ACKNOWLEDGEMENT',
  VERIFY_YOUR_INFO = 'VERIFY_YOUR_INFO',
  IDENTITY_FAILED = 'IDENTITY_FAILED',
  LOAN_SELECTION = 'LOAN_SELECTION',
  LENDER_INFO = 'LENDER_INFO',
}
